import { css } from "styled-components";
import colors from "../../tokens/colors";

export const PaperCardVariables = css`
  --paper-card-background-color: ${colors.primary.white};
`;
